













import SimpleInput from '@/UI/Shared/SimpleInput.vue'
import FieldModel from '@/UI/Shared/Mixins/FieldModel'
import mixins from 'vue-typed-mixins'

export default mixins(FieldModel).extend({
  name: 'NonEmptyInput',
  components: { SimpleInput },
  props: {
    label: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      inputStatus: ''
    }
  },
  methods: {
    validateInput () {
      if (this.currentValue === '' && this.required === false) {
        this.inputStatus = ''
      }
      if (this.currentValue === '' && this.required) {
        this.inputStatus = 'danger'
      }
      if (this.currentValue !== '') {
        this.inputStatus = 'success'
      }
    }
  }
})
